import { createContext } from "react"
import { useTranslation } from "react-i18next";
import ResumeStepFiveIconSVG from "assets/svg/resume-step-five-icon";
import ResumeStepFourIconSVG from "assets/svg/resume-step-four-icon";
import ResumeStepOneIconSVG from "assets/svg/resume-step-one-icon";
import ResumeStepThreeIconSVG from "assets/svg/resume-step-three-icon";
import ResumeStepTwoIconSVG from "assets/svg/resume-step-two-icon";
import ResumeStepQRIconSVG from "assets/svg/resume-step-qr-icon";
import EmptyPhotosIconSVG from "assets/svg/empty-photos-icon";
import EmptyVideosIconSVG from "assets/svg/empty-videos-icon";
import PhotoUploadIconSVG from "assets/svg/photo-icon-upload";
import VideoUploadIconSVG from "assets/svg/video-icon-upload";

export const LangContext = createContext();

export const LanguageProvider = ({ initials, children }) => {
    const {t} = useTranslation();
    const reportType = [
        {
          label: t("impersonation"),
          value: "Impersonation",
        },
        {
          label: t("inappropriateContent"),
          value: "Inappropriate Content",
        },
        {
          label: t("harassmentOrAbuse"),
          value: "Harassment or Abuse",
        },
        {
          label: t("spamOrScams"),
          value: "Spam or Scams",
        },
        {
          label: t("falseOrMisleadingInformation"),
          value: "False or Misleading Information",
        },
        {
          label: t("copyrightOrIntellectualPropertyViolation"),
          value: "Copyright or Intellectual Property Violation",
        },
        {
          label: t("hateSpeechOrDiscrimination"),
          value: "Hate Speech or Discrimination",
        },
        {
          label: t("fakeOrMisleadingLinks"),
          value: "Fake or Misleading Links",
        },
        {
          label: t("selfHarmOrSuicideConcerns"),
          value: "Self-Harm or Suicide Concerns",
        },
        {
          label: t("other"),
          value: "Other",
        }
      ];

      const MESSAGETYPE = [
        { value: "Availability check", label: t("availabilityCheck") },
        { value: "Invitation to audition", label: t("invitationToAudition") },
        {
          value: t("invitationToSubmitAProposal"),
          label: "Invitation to submit a proposal",
        },
        { value: "Offer", label: t("offer") },
        { value: "Other", label: t("otherWrite") },
      ];

       const sideBarMenuList = [
        {
          label: t("template"),
          value: "template",
        },
        {
          label: t("personalInfo"),
          value: "personal",
        },
        {
          label: t("moreInfo"),
          value: "more",
        },
        {
          label: t("milestones"),
          value: "milestone",
        },
        {
          label: t("qrCodes"),
          value: "qrcode",
        },
        {
          label: t("shareDownload"),
          value: "download",
        },
      ];

      const stepsInfo = [
        { label: t("selectATemplate"),
          icon: <ResumeStepOneIconSVG /> ,
          step: t('step1')
        },
        { label: t('showHidePersonalInfo'),
          icon: <ResumeStepTwoIconSVG />,
          step: t('step2')
         },
        { label: t('showHideMoreInfo'),
          icon: <ResumeStepThreeIconSVG />,
          step: t('step3')
         },
        { label: t('showHideMilestones'),
          icon: <ResumeStepFourIconSVG />,
          step: t('step4')
        },
        { label: t('showHideQRCodes'),
          icon: <ResumeStepQRIconSVG />,
          step: t('step5')
        },
        { label: t('shareOrDownload'),
          icon: <ResumeStepFiveIconSVG />,
          step: t('step6')
        },
      ];

      const colorOptions = [
        {
          label: t('blueOrange'),
          value: ["#3885FF", "#E5EFFA", "#EF6B33", "#2063CD"],
          color: ["#3885FF", "#EF6B33"],
          key: "theme-one",
        },
        {
          label: t('greenYelow'),
          value: ["#1D845E", "#DEEDE8", "#CA9E00", "#176F4F"],
          color: ["#1D845E", "#CA9E00"],
          key: "theme-two",
        },
        {
          label: t('pinkDark'),
          value: ["#E1529F", "#F5E2ED", "#920046", "#C7498D"],
          color: ["#E1529F", "#C7498D"],
          key: "theme-three",
        },
        {
          label: t('yellowBlue'),
          value: ["#E8B42D", "#F7EED9", "#4387C9", "#CD9914"],
          color: ["#E8B42D", "#4387C9"],
          key: "theme-four",
        },
        {
          label: t('violetPink'),
          value: ["#794BDA", "#F0EBFC", "#E82D9D", "#6332CB"],
          color: ["#794BDA", "#E82D9D"],
          key: "theme-five",
        },
      ];

      const HAIR_COLOR = [
        { label: t("black"), value: "Black" },
        { label: t("blonde"), value: "Blonde" },
        { label: t("brown"), value: "Brown" },
        { label: t("darkBrown"), value: "Dark Brown" },
        { label: t("red"), value: "Red" },
      ];
      
      const EYE_COLOR = [
        { label: t("amber "), value: "Amber" },
        { label: t("blue"), value: "Blue" },
        { label: t("brown"), value: "Brown" },
        { label: t("gray"), value: "Gray" },
        { label: t("green"), value: "Green" },
        { label: t("hazel"), value: "Hazel" },
      ];

      const CHILD = [
        { label: t("0Children"), value: 0 },
        { label: t("1Children"), value: 1 },
        { label: t("2Children"), value: 2 },
        { label: t("3Children"), value: 3 },
        { label: t("4Children"), value: 4 },
        { label: t("5Children"), value: 5 },
        { label: t("6Children"), value: 6 },
        { label: t("7Children"), value: 7 },
        { label: t("8Children"), value: 8 },
        { label: t("9Children"), value: 9 },
        { label: t("10Children"), value: 10 },
      ];
      const CIVIL_STATUS = [
        { label: t("married"), value: "Married" },
        { label: t("widowed"), value: "Widowed" },
        { label: t("separated"), value: "Separated" },
        { label: t("divorced"), value: "Divorced" },
        { label: t("single"), value: "Single" },
      ];
      
      const headerLinks = [
        {
          id: 1,
          label: t("features"),
          path: "/features"
        },
        // {
        //   id: 2,
        //   label: t("aboutUs"),
        //   path: "/about-us"
        // },
        // {
        //   id: 3,
        //   label: t("pricing"),
        //   path: "/plans"
        // },
        {
          id: 4,
          label: t("fAQ"),
          path: "/faqs"
        }
      ];

    const heroTypes = [
      { label: t("buyMeACoffee"), value: "Buy Me a Coffee" },
      { label: t("upwork"), value: "Upwork" },
      { label: t("freelancer"), value: "Freelancer" },
      { label: t("subscribeStar"), value: "SubscribeStar" },
      { label: t("locals"), value: "Locals" },
      { label: t("hipages"), value: "Hipages" },
      { label: t("substack"), value: "Substack" },
      { label: t("ko-fi"), value: "Ko-fi" },
      { label: t("fiverr"), value: "Fiverr" },
      { label: t("onlyfans"), value: "Onlyfans" },
      { label: t("patreon"), value: "Patreon" },
      { label: t("other"), value: "Other" },
    ];

    const heroCTAs = [
      { label: t("checkMeOut"), value: "Check me out on" },
      { label: t("supportMeOn"), value: "Support me on" },
      { label: t("subscribeOn"), value: "Subscribe on" },
      { label: t("hireMeOn"), value: "Hire me on" },
      { label: t("visitMyShop"), value: "Visit My Shop" },
    ];


    const languages = [//the value also used in database backend as a column name
      { label: t("english"), value: "en" },
      { label: t("hindi"), value: "hi" },
      { label: t("spanish"), value: "es" },
      { label: t("french"), value: "fr" },
      { label: t("arabic"), value: "ar" },
      { label: t("bengali"), value: "bn" },
      { label: t("portuguese"), value: "pt" },
      { label: t("urdu"), value: "ur" },
      { label: t("russian"), value: "ru" },
      { label: t("chinese"), value: "ch" }
    ];

    const TypeOject = {
      emptIcon: {
        photo: <EmptyPhotosIconSVG />,
        video: <EmptyVideosIconSVG />,
      },
      loading: {
        photo: `${t('loadingPhotos')} ...`,
        video: `${t('loadingVideos')} ...`,
      },
      accept: {
        photo: "image/*",
        video: "video/mp4,video/x-m4v,video/*",
      },
      uploadIcon: {
        photo: <PhotoUploadIconSVG />,
        video: <VideoUploadIconSVG />,
      },
    };

      return(
        <LangContext.Provider
            value={{
                reportType,
                MESSAGETYPE,
                sideBarMenuList,
                stepsInfo,
                colorOptions,
                HAIR_COLOR,
                EYE_COLOR,
                CHILD,CIVIL_STATUS,
                headerLinks,
                heroTypes,
                heroCTAs,
                languages,
                TypeOject
            }}
        >
            {children}
        </LangContext.Provider>
      )
      
}